import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const BrandWrapper = styled.div`
    height: 100%;
    width: auto;
    display: flex;
    align-items: center;
    padding: ${SPACING.SMALL_4};
    @media ${BreakpointsMinQuery.lg} {
        padding: ${SPACING.MEDIUM_2};
        width: 228px;
    }
`;

export const BrandLogoContainer = styled.div`
    color: ${Colors.primary};
    display: block;
    height: 20px;
    min-width: 20px;
`;
